import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {TranslateService} from '@ngx-translate/core';
import {catchError} from 'rxjs/operators';
import {LoginProvider} from "../providers/login/login";
import {AlertController, App, ToastController} from "ionic-angular";

@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ]
})
export class SessionExpiredInterceptorModule implements HttpInterceptor {

  constructor(private loginProvider: LoginProvider,
              private app: App,
              private translateService: TranslateService,
              private alertController: AlertController,
              private toastController: ToastController) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // this.app.getActiveNav().setRoot()
    return next.handle(req).pipe(catchError(err => {
      if (this.loginProvider.userToken !== null && err.status === 401) {
        if (err.error.reason) {
          this.alertController.create({
            title: this.translateService.instant("your_session_has_expired"),
            message: err.error.reason,
            buttons: [{
              text: 'Ok',
              role: 'cancel'
            }]
          }).present();
        }
        // auto logout if 401 response returned from api
        this.loginProvider.logOut();
        this.translateService.get([
          'please_log_in_again'
        ]).subscribe(translations => {
          const toast = this.toastController.create({
            message: translations['please_log_in_again'],
            duration: 3000,
          });
          // toast.present();
          this.app.getRootNav().setRoot('LogPage', {}, {
            direction: 'back'
          });
        });
      }

      return Observable.throw(err);
    }));
  }
}



// WEBPACK FOOTER //
// ./src/interceptors/session-expired-interceptor.module.ts